<template>
  <svg
    class="user-icon"
    :viewBox="`0 0 ${size} ${size}`"
    xmlns="http://www.w3.org/2000/svg"
    :style="`height: ${size}px; width: ${size}px`"
    fill="#456E6C"
  >
    <circle
      fill="#456E6C"
      :r="size/2"
      :cx="size/2"
      :cy="size/2"
    />
    <text
      text-anchor="middle"
      :x="size/2"
      :y="size/2"
      :font-size="size*(15/36)+'px'"
      dominant-baseline="central"
      fill="white"
      class="user-icon__content"
    >
      {{ userInitials }}
    </text>
  </svg>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'AccountIcon',
    props: {
      size: {
        type: Number,
        default: 36,
      },
    },
    computed: {
      ...mapGetters({ currentUser: 'Users/currentUser' }),
      userInitials () {
        let initials = ''
        if (this.currentUser.firstName) initials += this.currentUser.firstName[0]
        if (this.currentUser.lastName) initials += this.currentUser.lastName[0]
        return initials
      },
    },
  }
</script>

<style lang="scss">
.user-icon {
    display: flex;
    text-align: center;
    border-radius: 100px;
    & .user-icon__content {
      flex: none;
      margin: auto;
      font-family: 'Lato', sans-serif;
      font-style: normal;
      font-weight: bold;
      letter-spacing: 1px;
      text-transform: uppercase;
      vertical-align: middle;
    }
}
</style>
